<template>
    <div class="job_details">
    <div :class="`detail_logo ${organisation.id}`">
      <div :class="`big_bg ${organisation.id}`"></div>
      <job-logos :qrcode="true" :organisation="organisation" :class="`jl_single ${organisation.id}`"></job-logos>
    </div>

    <div class="jobs">

      <div class="job_details">
        <div class="jd_header">
          <div class="columns">
            <div class="column">
              <div class="columns">
              <div class="column j_name">Job Name</div>
              <div class="column is-narrow j_location">Location</div>
              </div>
            </div>
              <div class="column">
                <div v-if="jobs.data.length > 1">
                <div class="columns">
                    <div class="column j_name">Job Name</div>
                    <div class="column is-narrow j_location">Location</div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="job_in_company">
          <div class="columns">
            <div class="column" v-if="loading === false">
              <div class="columns "  v-for="job in filteredItems(1,2)">
                <div class="column j_name">{{job.attributes.title}}</div>
                <div class="column is-narrow j_location">
                  <div v-if="job.relationships.location.data !== null">
                  {{getJobLocation(job.relationships.location.data.id)}}
                  </div>
                  <div v-else>- -</div>
                </div>
              </div>
            </div>
            <div class="column" v-if="loading === false">
              <div class="columns " v-for="job in filteredItems(2,2)">
                <div class="column j_name">{{job.attributes.title}}</div>
                <div class="column is-narrow j_location">
                  <div v-if="job.relationships.location.data !== null">
                    {{getJobLocation(job.relationships.location.data.id)}}
                  </div>
                  <div v-else>- -</div>
                </div>
              </div>
              </div>
            </div>
          </div>
      </div>
    </div>

</template>
<script>

  import JobLogos from '@/components/jobs/JobLogos';
  import JobList from '@/components/jobs/JobList';
  import JobItem from '@/components/jobs/JobItem';
  import axios from 'axios';

  export default {
    name: 'job-details',
    props: ['organisation', 'qrcode'],
    created() {
    },

    computed: {

    },
    methods: {

      getJobLocation(jobId) {
        let location = 'no location';
        this.jobs.included.forEach((job) => {
          if (job.id === jobId) {
            location = job.attributes.city;
          }
        });
        return location;
      },
      filteredItems(column, columns) {
        const self = this;
        const total = this.jobs.data.length;
        const gap = Math.ceil(total / columns);
        let top = (gap * column);
        const bottom = (top - gap);
        top -= 1;
        return self.jobs.data.filter(j =>
            self.jobs.data.indexOf(j) >= bottom
            && self.jobs.data.indexOf(j) <= top,
          );
      },
      getJobs() {
        if (this.organisation.id !== null) {
          const URL = `${this.$config.API}/api/org/${this.organisation.id}/jobs?include=location&pageSize=30`;
          axios.get(URL).then((res) => {
            this.loading = false;
            this.jobs = res.data;
          });
        }
      },
    },
    data() {
      return {
        loading: false,
        jobs: {
          data: [
            {
              attributes: {
                title: 'Loading data',
              },
              relationships: {
                location: {
                  data: {
                    id: null,
                  },
                },
              },
            },
          ],
          included: [
            {
              attributes: {
                city: null,
              },
            },
          ],
        },
      };
    },
    watch: {
      // eslint-disable-next-line
      'organisation': function () {
        this.loading = true;
        this.getJobs();
      },
    },
    components: {
      JobList,
      JobLogos,
      JobItem,
    },
  };
</script>

<style scoped lang="scss">


  .detail_logo {
    height: 80px;
    position: relative;

    .jl_single {
      position: absolute;
      z-index: 2;
      padding:6px;
      background: #fff;
      top: 0px;
    }

    .big_bg {

      height: 80px;
      width: 100%;
      background-size: cover !important;
      background-position: center center !important;
      filter: brightness(1) blur(22px) opacity(0.0);
      position: absolute;
      z-index: 1;
      overflow: hidden;
    }

    .big_bg.ricardo {
      background: url('/static/img/logo_ri.jpg');
    }

    .big_bg.olmero {
      background: url('/static/img/logo_ol.jpg');
    }

    .big_bg.tutti {
      background: url('/static/img/logo_tu.jpg');
    }

    .big_bg.homegate {
      background: url('/static/img/logo_hg.jpg');
    }

    .big_bg.starticket {
      background: url('/static/img/logo_sk_black_blue.jpg');
    }

    .big_bg.doodle {
      background: url('/static/img/logo_dd.jpg');
    }
    .big_bg.pux {
      background: url('/static/img/logo_pux.png');
    }


    .jl_single.tamedia_ag {
      border: none;
      padding: 0;
      box-shadow: none;
    }


  }

  .detail_logo.tamedia_ag {
    height: 115px;
  }


</style>



// WEBPACK FOOTER //
// src/components/jobs/JobDetails.vue